// Page-wide CSS rendered once by App.js with <GlobalStyles styles={portalGlobalStyles} />,
// on every page (public and signed in). It deliberately does not reset the
// body margin: AboutUs, ContactUs, PrivacyPolicy and TermCondition still wrap
// themselves in margin -8px to cancel the browser's 8-px body margin, so MUI's
// <CssBaseline /> stays inside the signed-in shell (ResponsiveDrawer) and the
// login page.

import { ethiopicFontFaceCss } from './fonts';
import { tokens as c } from './tokens';

const css = [
  ethiopicFontFaceCss(),
  // No grey flash on tap; text size stays as designed when a phone rotates.
  'html{-webkit-tap-highlight-color:transparent;-webkit-text-size-adjust:100%;text-size-adjust:100%;}',
  // No double-tap zoom delay on controls, and a long press does not select a button's words.
  ':where(a,button,[role="button"],label){touch-action:manipulation;}',
  ':where(button,[role="button"]){-webkit-user-select:none;user-select:none;}',
  // iOS zooms into inputs under 16 px; only on touch screens, so desktop forms keep their size.
  // :where() keeps this at zero specificity, so a field styled bigger keeps its size.
  '@media (pointer:coarse){:where(input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),select,textarea){font-size:16px;}}',
  // A visible keyboard focus ring on plain links (MUI controls draw their own).
  `:where(a):focus-visible{outline:2px solid ${c.ACCENT_TEXT};outline-offset:2px;}`,
  // Calm motion: people who ask for less motion get none, except spinners,
  // which must keep turning to show the page is still working.
  '@media (prefers-reduced-motion:reduce){' +
    '*:not(.MuiCircularProgress-root):not(.MuiCircularProgress-svg):not(.MuiCircularProgress-circle):not(.MuiLinearProgress-bar),*::before,*::after{' +
    'animation-duration:0.01ms!important;animation-iteration-count:1!important;transition-duration:0.01ms!important;scroll-behavior:auto!important;}}',
].join('\n');

export const portalGlobalStyles = css;

export default portalGlobalStyles;
